import { defineMessages } from "react-intl";
const messages = defineMessages({
    actionsEdit: {
        id: "app.admin.editUser.edit.text",
        defaultMessage: "Edit user",
    },
    actionsObserve: {
        id: "app.admin.observeUser.observe.text",
        defaultMessage: "Login as this user",
    },
});
export default messages;
